import PropTypes from 'prop-types';
import NotPermissionView from 'src/sections/error/NotPermissionView';

import { hasPermission } from 'src/utils/helpers';
import { useAuthContext } from '../hooks';

export default function RoleBasedGuard({ permission, children }) {
  const { user } = useAuthContext();

  if (permission && !hasPermission(user, permission)) return <NotPermissionView />;
  return <> {children} </>;
}

RoleBasedGuard.propTypes = {
  permission: PropTypes.string,
  children: PropTypes.node,
};
